module.exports = __webpack_public_path__ + "static/about-content-image-1@2x-b68be67bf54fdbee5ff0c53669314c11.jpg";